// node_modules
import { FC, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";

import styles from "./sidebarMediasPreviewFilterMenu.module.scss";

type TSidebarMediasPreviewFilterMenuProps = {
    defaultSelectedPreviewName: string;
    children: JSX.Element[],
    addElement?: (previewType: string) => void
};

export const SidebarMediaPreviewFilterMenu: FC<TSidebarMediasPreviewFilterMenuProps> = ({ children, defaultSelectedPreviewName, addElement }: TSidebarMediasPreviewFilterMenuProps) => {
    const [selectedPreviewName, setSelectedPreviewName] = useState(defaultSelectedPreviewName);

    // We set the currently mapped child
    let currentlyMappedChild: JSX.Element | undefined;
    children.forEach(child => {
        if(child.props.previewName === selectedPreviewName) {
            currentlyMappedChild = child;
        }
    });

    useEffect(() => {
        setSelectedPreviewName(defaultSelectedPreviewName);
    }, [defaultSelectedPreviewName]);

    // In order to put all media preview of the same type under the correct media type on the render
    // We need to first get all children props (of type TMediaPreviewTypeChildProps)
    const allChildrenProps: {previewName: string, previewType: string, previewLink: string}[] = children.map(child => child.props);

    return (
        <div className={styles.menuAndContentContainer}>
            <div className={styles.contentContainer}>
                {currentlyMappedChild ? 
                    currentlyMappedChild 
                    : 
                    <div className={styles.aspectRatioBoxEmpty}>
                        <div className={styles.aspectRatioBoxContentEmpty}>
                            Media
                        </div>
                    </div>
                }
            </div>
            <div className={styles.menuContainer}>
                <div className={styles.thumbnailsContainer}>
                    {// We display all media preview
                    }
                    {allChildrenProps.length > 1 || addElement ?
                        allChildrenProps
                            .map((childProps, index) => {
                                if (childProps.previewType === "Videos") {
                                    return (
                                        <div className={styles.thumbnailContainer} key={index} onClick={() => { setSelectedPreviewName(childProps.previewName); }}>
                                            <img className={styles.thumbnailImage} src={childProps.previewLink} alt={childProps.previewName} />
                                            <div className={styles.thumbnailImageIcon}>
                                                <FontAwesomeIcon icon={faPlayCircle} />
                                            </div>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className={styles.thumbnailContainer} key={index} onClick={() => { setSelectedPreviewName(childProps.previewName); }}>
                                            <img className={styles.thumbnailImage} src={childProps.previewLink} alt={childProps.previewName} />
                                        </div>
                                    );
                                }
                                
                            })
                        : null }

                    {addElement ? <div className={[styles.thumbnailContainer, styles.addMedia].join(" ")} title={"Add media"} onClick={ () => { addElement("figures"); } }>
                        +
                    </div> : null}
                </div>
            </div>
        </div>
    );
}